import { useQueryClient } from "@tanstack/react-query";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { authKeys, useMe } from "@/modules/auth/hooks/useAuth";
import { PageHeader } from "@/shared/components/PageHeader";
import { PhoneInput } from "@/shared/components/PhoneInput";
import { useUpdateUser } from "../hooks/useUsers";

export function ProfilePage() {
	const [form] = Form.useForm<{ fullname: string; phone: string; password?: string }>();
	const { data: meUser } = useMe();
	const queryClient = useQueryClient();
	const { mutate: update, isPending } = useUpdateUser();

	useEffect(() => {
		if (meUser) {
			form.setFieldsValue({
				fullname: meUser.fullname,
				phone: meUser.phone,
			});
		}
	}, [meUser, form]);

	const onFinish = (values: { fullname: string; phone: string; password?: string }) => {
		if (!meUser?.id) {
			return;
		}
		const updateData: { fullname?: string; phone?: string; password?: string } = {};
		if (values.fullname !== meUser.fullname) {
			updateData.fullname = values.fullname;
		}
		if (values.phone !== meUser.phone) {
			updateData.phone = values.phone;
		}
		if (values.password) {
			updateData.password = values.password;
		}

		if (Object.keys(updateData).length > 0) {
			update(
				{ id: meUser.id, data: updateData },
				{
					onSuccess: () => {
						queryClient.invalidateQueries({ queryKey: authKeys.me() });
					},
				}
			);
		}
	};

	return (
		<div>
			<PageHeader title="Profil sozlamalari" />
			<Card>
				<Form
					form={form}
					layout="vertical"
					requiredMark={false}
					onFinish={onFinish}
					initialValues={{ fullname: meUser?.fullname, phone: meUser?.phone }}
				>
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item
								name="fullname"
								label="To'liq ism"
								rules={[{ required: true, message: "Ismni kiriting" }]}
							>
								<Input placeholder="Abdullayev Sardor" id="profile-fullname" />
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								name="phone"
								label="Telefon raqam"
								rules={[
									{ required: true, message: "Telefon raqamni kiriting" },
									{ pattern: /^\+998\d{9}$/, message: "To'liq 9 ta raqam kiriting" },
								]}
							>
								<PhoneInput id="profile-phone" />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col span={12}>
							<Form.Item name="password" label="Yangi parol (ixtiyoriy)">
								<Input.Password
									placeholder="O'zgartirmasangiz bo'sh qoldiring"
									id="profile-password"
									autoComplete="new-password"
								/>
							</Form.Item>
						</Col>
					</Row>
					<Form.Item>
						<Button type="primary" htmlType="submit" loading={isPending}>
							Saqlash
						</Button>
					</Form.Item>
				</Form>
			</Card>
		</div>
	);
}
